import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';

class AdminFileSizesHeader extends PureComponent {
  render() {
    const {
      intl,
      sizesVisible,
      sizesTotal,
      loading,
      handleAddSize,
    } = this.props;

    return (
      <header id="sizes-list-header" className="page-header">
        <h3 className="page-title">
          {intl.formatMessage({ defaultMessage: 'File sizes' })}
        </h3>
        <div className="header-actions users-actions">
          <div className="items-displaying users-displaying">
            {(!loading && sizesTotal > 0) && (
              <span>
                {intl.formatMessage(
                  { defaultMessage: '{sizesVisible} of {sizesTotal} sizes' },
                  { sizesVisible, sizesTotal },
                )}
              </span>
            )}
          </div>
          <div className="button-wrapper">
            <Button color="primary" onClick={handleAddSize}>
              <i className="fas fa-plus" />
              <span>
                {intl.formatMessage({ defaultMessage: 'File size' })}
              </span>
            </Button>
          </div>
        </div>
      </header>
    );
  }
}

AdminFileSizesHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  sizesVisible: PropTypes.string.isRequired,
  sizesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  handleAddSize: PropTypes.func.isRequired,
};

export default injectIntl(AdminFileSizesHeader);
